import type { SVGProps } from 'react';
const DawnFlagLK = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-LK_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-LK_svg__a)">
      <path fill="#FFBF19" d="M0 0h22v16H0z" />
      <path
        fill="#A52531"
        fillRule="evenodd"
        d="M8.38 1.067H19.62c.736 0 1.333.597 1.333 1.333v11.2c0 .736-.597 1.333-1.333 1.333H8.381z"
        clipRule="evenodd"
      />
      <path
        fill="#03664F"
        d="M1.048 2.4c0-.736.597-1.333 1.333-1.333h1.81v13.866H2.38A1.333 1.333 0 0 1 1.048 13.6z"
      />
      <rect width={3.143} height={13.867} x={4.19} y={1.067} fill="#FF6816" rx={0.667} />
      <path
        fill="#FFBF18"
        fillRule="evenodd"
        d="M10.476 2.667a.53.53 0 0 1-.523.533.53.53 0 0 1-.524-.533v-.534h.524c.289 0 .523.24.523.534m8.381 0c0 .294.235.533.524.533s.524-.239.524-.533v-.534h-.524a.53.53 0 0 0-.524.534m.524 10.133a.53.53 0 0 0-.524.533c0 .295.235.534.524.534h.524v-.534a.53.53 0 0 0-.524-.533m-8.905.533a.53.53 0 0 0-.523-.533.53.53 0 0 0-.524.533v.534h.524c.289 0 .523-.24.523-.534M12.572 10.05a.45.45 0 0 0-.45-.45.4.4 0 0 1-.144-.025c-.304-.11-1.502-.576-1.502-1.042 0-.26.124-.519.252-.717.145-.226.204-.51.112-.763-.178-.49-.434-1.294-.364-1.72a1 1 0 0 1 .223-.455c.308-.374.825-.062.825.423v1.757c0 .25.14.48.364.594l.45.23a.356.356 0 1 0 .323-.635l-.613-.314V6.4c.264 0 .35-.355.114-.475l-.114-.058v-.534h.768c.178 0 .35-.071.475-.2L13.423 5a.67.67 0 0 1 .476-.2h.352c.255 0 .487.145.599.373l.22.45c.078.156.09.336.036.502l-.153.468a.667.667 0 0 0 .633.874h1.524a.42.42 0 0 0 .19-.793l-.395-.201a.7.7 0 0 0-.303-.073h-.221a.667.667 0 0 1-.667-.667v-.127c0-.175.069-.342.191-.467l.333-.339v.543c0 .29.235.524.524.524h.632c.255 0 .487.144.599.373l.289.588q.052.106.062.222c.025.287.078 1.034-.01 1.483-.07.35-.254.676-.385.874a.8.8 0 0 0-.14.432v1.492a.402.402 0 1 1-.763-.177l.186-.378a.25.25 0 0 0 0-.218l-.024-.05c-.11-.223-.446-.145-.446.104a.24.24 0 0 1-.024.104l-.37.755a.47.47 0 0 1-.844-.415l.124-.254a.65.65 0 0 0 .066-.285v-.25a.667.667 0 0 0-.666-.667h-.762a.667.667 0 0 0-.667.667v.245a.7.7 0 0 1-.068.294l-.327.665a.47.47 0 0 1-.844-.415l.125-.254a.65.65 0 0 0 .066-.285z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagLK;
